var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopRoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "StopRoll_svg__a",
    d: "M5.333 5.333h53.333v53.333H5.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.576)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "StopRoll_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#StopRoll_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#StopRoll_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.333 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.874 35h35.693c.821 0 1.487-.783 1.487-1.75V1.75c0-.966-.666-1.75-1.487-1.75H32.874c-.82 0-1.487.784-1.487 1.75v31.5c0 .967.666 1.75 1.487 1.75",
    fill: "#2175D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.731 36.767c0-3.258 2.63-5.9 5.876-5.9 3.244 0 5.875 2.642 5.875 5.9 0 3.258-2.63 5.9-5.875 5.9s-5.876-2.642-5.876-5.9",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.669 36.747a2.939 2.939 0 112.938 2.94 2.939 2.939 0 01-2.938-2.94",
    fill: "#F7F5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFB511",
    y: 34.909,
    width: 29.551,
    height: 3.675,
    rx: 1.837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.852 30.316a2.755 2.755 0 012.754 2.756 2.755 2.755 0 11-2.754-2.756zm9.18 0a2.755 2.755 0 012.754 2.756 2.755 2.755 0 11-2.754-2.756zm-9.18 1.837a.918.918 0 100 1.837.918.918 0 000-1.837zm9.18 0a.918.918 0 10.001 1.837.918.918 0 000-1.837z",
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BA5B4",
    d: "M9.18 5.512h16.524v23.885H9.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFB511",
    x: 1.836,
    y: 31.235,
    width: 1.836,
    height: 5.512,
    rx: 0.918
  }))), /*#__PURE__*/React.createElement("circle", {
    stroke: "#E74536",
    strokeWidth: 2,
    mask: "url(#StopRoll_svg__b)",
    cx: 16,
    cy: 44,
    r: 9.333
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgStopRoll as ReactComponent };